import React from 'react';

import {Tabs} from "../../../core/components/tabs/components/tabs";
import {observer} from 'mobx-react';
import {PREDICTION_WIDGET} from "../predictions-widget.consts";

export const PredictionWidgetTabs = observer(({controller}) => {
  const {state} = controller;
  const {shouldRenderTabs, tabIndex, tabs, currentContext, sportTypeId, statusGroup, config} = state
  const {source} = config;

  const tabProps = {
    tabs,
    shouldRenderTabs,
    initialIndex: tabIndex,
    onTabChange: (tab) => {
      controller.action(PREDICTION_WIDGET.ACTION_TYPES.tabChange, {index: tab.index});
      controller.action(PREDICTION_WIDGET.ACTION_TYPES.onTabClick, {
        gameId: currentContext?.selectedCard?.gameId,
        athleteId: currentContext?.selectedCard?.athlete?.id,
        tabName: tab?.analyticsLabel,
        status: statusGroup,
        sportTypeId,
        source,
      })
    }
  }

  return shouldRenderTabs ? <Tabs {...tabProps}/> : null
});
